export const getExternalLink = (link: string): string => {
  return link.startsWith('http://') || link.startsWith('https://') ? link : `//${link}`;
};
